export const READY_EMPLOYER = true;
// export const READY_EMPLOYER = process.env.REACT_APP_READY_EMPLOYER === "yes";
// console.log("env var", process.env.REACT_APP_READY_EMPLOYER);
// ready employer use cases
// - videos will be shown in job page
// - (temp) navbar shows a flag

export const ActionType = {
  setUserData: "setUserData",
  logout: "logout",
  error: "error",
  updateSurvey: "updateSurvey",
  updateSurveyFromServer: "updateSurveyFromServer",
  adminSurveyFromServer: "adminSurveyFromServer",
  updateDefaultSalaryIdx: "updateDefaultSalaryIdx",
  setJobs: "setJobs",
  toggleFavJob: "toggleFavJob",
  addEdu: "addEdu",
  loadedYtScript: "loadedYtScript",
  eduIdNotFound: "eduIdNotFound",
  setApplyData: "setApplyData",
  updateAppData: "updateAppData",
  updateApplyData: "updateApplyData",
  updateApplyServerData: "updateApplyServerData",
  setAllChats: "setAllChats",
  updateAllChats: "updateAllChats",
  selectChat: "selectChat",
  setFullChat: "setFullChat",
  setChatInput: "setChatInput",
  // setApplicationAttachmentData is old version of setMyApps
  // former loads one, latter loads all and uses id+data tracking structure
  setApplicationAttachmentData: "setApplicationAttachmentData",
  setMyApps: "setMyApps",
  appendChatHistory: "appendChatHistory",
  successLocalMessage: "successLocalMessage",
  failLocalMessage: "failLocalMessage",
  retryLocalMessage: "retryLocalMessage",
  setResumeUrl: "setResumeUrl",
  updateSchools: "updateSchools",
  deleteSchool: "deleteSchool",
  setProfilePicUrl: "setProfilePicUrl",
  updateServerCompany: "updateServerCompany",
  setRecipientProfilePic: "setRecipientProfilePic",
  setNumUnread: "setNumUnread",
  removeLocalJobById: "removeLocalJobById",
};

export const IhaOp = {
  getChats: "get_chats",
  // get_full_chat
  getFullChat: "get_full_chat",
  // get_application_data
  getApplicationData: "get_application_data",
  messageBasic: "message_basic",
  // get_resume
  getResume: "get_resume",
  // get_schools = 'get_schools'
  // add_school = 'add_school'
  // update_school = 'update_school'
  // delete_school = 'delete_school'
  getSchools: "get_schools",
  addSchool: "add_school",
  updateSchool: "update_school",
  deleteSchool: "delete_school",
  getNumUnread: "get_num_unread",
  // get_all_application_data
  getAllApplicationData: "get_all_application_data",
};

export const EdaOp = {
  getCompanyInfo: "get_company_info",
};

export const ReportOp = {
  // report_job
  reportJob: "report_job",
};

export const ErrorCode = {
  invalidCredentials: "invalid_credentials",
  noAccountExists: "no_account_exists",
  emailAlreadyExists: "email_already_exists",
  missingRequiredFields: "missing_required_fields",
  noSurveyData: "no_survey_data",
  noJobMatches: "no_job_matches",
  invalidData: "invalid_data",
  passwordsDoNotMatch: "passwords_do_not_match",
  tokenExpired: "token_expired",
  not_admin: "not_admin",
};

export const Slug = {
  home: "/",
  login: "/login",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  emptySurvey: "/preferences",
  surveyInitial: "/preferences/quality",
  survey: "/preferences/:section",
  emptyGigSurvey: "/survey",
  surveyGigInitial: "/survey/location",
  surveyGig: "/survey/:section",
  results: "/results",
  settings: "/settings",
  jobResults: "/job-results",
  matchesOnly: "/matches",
  unsubscribe: "/unsubscribe",
  sentVerificationEmail: "/sent-verification-email",
  verifyEmail: "/verify",
  education: "/university",
  signUp: "/sign-up",
  signUpSuccess: "/sign-up-success",
  referralSignup: "signup",
  signupNoref: "/signup-now",
  admin: "/talent-HQ",
  apply: "/apply",
  alreadyApplied: "/already-applied",
  applySuccess: "/apply-success",
  inbox: "/inbox",
  myApplications: "/my-applications",
  googleApiServicesDisclosure: "/google-api-services-disclosure",

  affiliateSite: "https://affiliate.tryfetti.com/",
  privacyPolicy: "https://about.tryfetti.com/privacy-policy/",
  termsAndConditions: "https://about.tryfetti.com/terms-and-conditions/",
};

export const Color = {
  primary: "#FFFC00",
  primaryDark: "rgb(230, 210, 33)",
  primaryLight: "rgb(250, 250, 150)",
  secondaryTextGray: "rgb(119, 119, 119)",
  bgMed: "rgb(240, 240, 237)",
  bgDark: "rgb(230, 230, 227)",
  bgLight: "rgb(247, 247, 244)",
  borderGray: "rgb(225, 225, 219)",
  lightGreen: "#BAFBC4",
  mainGreen: "#3BF77A",
  darkGreen: "#00E639",
  altMainGreen: "rgb(74,139,100)",
  altLightGreen: "rgb(84,189,130)",
  lightBlue: "#A6EFF5",
  mainBlue: "#5E61F5",
  fettiLightBlue: "#7EE7F2",
  fettiPurple: "#BBB0D0",
  deepPurple: "#6762F5",
  deeperPurple: "#4939D1",
};
// export const defaultBottomPadding = '100px'
export const defaultBottomPadding = "0px";
export const defaultContainerStyle = {
  width: "100%",
  height: "100%",
  paddingTop: "23px",
  paddingBottom: "0px",
  // px: '0.75rem',
};
export const defaultInnerStyle = {
  width: { xs: "100%", sm: "500px" },
  // px: '0.75rem',
};

// export const navPaddingTop = { xs: '133px', sm: '86px' }
export const navPaddingTop = { xs: "75.5px", sm: "86px" };

const titleFont = "Libre Franklin";

export const FontStyle = {
  logo: {
    fontFamily: "Abril Fatface",
    // letterSpacing: "0.05em",
  },
  title: {
    // fontFamily: 'Hanken Grotesk',
    fontFamily: titleFont,
    fontWeight: 900,
    // letterSpacing: '-0.04rem',
  },
  styledButton: {
    // fontFamily: 'Hanken Grotesk',
    fontFamily: titleFont,
    fontWeight: 400,
  },
  body: {
    fontFamily: "DM Sans",
    fontWeight: 400,
  },
  menuButton: {
    fontFamily: "DM Sans",
    fontWeight: 700,
  },
  headingBody: {
    fontFamily: "DM Sans",
    fontWeight: 700,
  },
};

export const Inputs = {
  borderRadius: "6px",
  px: "12px",
  py: "9px",
  fontSize: "16px",
};

export const SurveyButtonStyle = {
  defaultStyling: {
    ...FontStyle.headingBody,
    fontSize: "1rem",
    textTransform: "none",
    transition: "all 0.25s ease-in-out 0s",
    height: "2.8rem",
  },
  primaryColor: {
    ...FontStyle.headingBody,
    backgroundColor: Color.mainGreen,
    color: "black",
    "&:hover": {
      backgroundColor: Color.darkGreen,
      boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    },
    boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
  },
  primaryNoShadow: {
    ...FontStyle.headingBody,
    backgroundColor: Color.mainGreen,
    color: "black",
    "&:hover": {
      backgroundColor: Color.darkGreen,
    },
  },
  yellowColor: {
    ...FontStyle.headingBody,
    backgroundColor: Color.primary,
    color: "black",
    "&:hover": {
      // backgroundColor: Color.primaryLight,
      backgroundColor: Color.primary,
      boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    },
    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
  },
  primaryColorScale: {
    ...FontStyle.headingBody,
    backgroundColor: Color.mainGreen,
    color: "black",
    "&:hover": {
      backgroundColor: Color.darkGreen,
      boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
      transform: "scale(1.05)",
    },
    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
  },
  whiteColor: {
    ...FontStyle.headingBody,
    backgroundColor: Color.bgMed,
    color: "black",
    border: `1px solid ${Color.bgDark}`,
    boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: Color.bgDark,
      boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    },
  },
  outlineColor: {
    ...FontStyle.headingBody,
    backgroundColor: "transparent",
    color: "black",
    border: `1px solid #000`,
    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "#0002",
      // border: `2px solid ${Color.bgDark}`,
      // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    },
  },
  grayColor: {
    ...FontStyle.headingBody,
    backgroundColor: "transparent",
    color: "#0006",
    border: `1px solid #0002`,
    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      color: "#000",
      border: `1px solid #000`,
      backgroundColor: "transparent",
    },
  },
  blueFill: {
    ...FontStyle.headingBody,
    color: "white",
    // color: "black",
    // opacity: disabled ? 0.5 : 1,
    backgroundColor: `${Color.deepPurple}`,
    border: `1px solid ${Color.deepPurple}`,
    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "transparent",
      color: Color.deepPurple,
      // border: `2px solid ${Color.bgDark}`,
      // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    },
    "&[disabled]": {
      backgroundColor: `${Color.deepPurple}50`,
      border: `1px solid transparent`,
      color: "white",
    },
  },
  blueOutline: {
    ...FontStyle.headingBody,
    backgroundColor: "transparent",
    color: Color.deepPurple,
    // color: "black",
    border: `1px solid ${Color.deepPurple}`,
    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: `${Color.deepPurple}D0`,
      color: "white",
      // border: `2px solid ${Color.bgDark}`,
      // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    },
  },
  redOutline: {
    ...FontStyle.headingBody,
    backgroundColor: "transparent",
    color: "black",
    border: `1px solid #f008`,
    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: `#f008`,
      // color: "white",
      // border: `2px solid ${Color.bgDark}`,
      // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    },
  },
  grayOutline: {
    ...FontStyle.headingBody,
    backgroundColor: "transparent",
    color: "black",
    border: `1px solid #0006`,
    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      border: `1px solid #000d`,
      backgroundColor: `#0002`,
      // color: "white",
      // border: `2px solid ${Color.bgDark}`,
      // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    },
  },
  gradientColor: {
    ...FontStyle.headingBody,
    backgroundSize: "300% 100%",
    backgroundImage:
      "linear-gradient(to right, rgba(250, 250, 150,0.5), #6dd5ed90, #6dd5ed90, rgba(250, 250, 150,0.5))",
    // "linear-gradient(to left, rgba(250, 250, 150,0.5), #6dd5ed90)",
    color: "black",
    // border: `1px solid ${Color.bgDark}`,
    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    transition: "all 0.35s ease-in-out 0s",
    "&:hover": {
      // backgroundColor: "transparent",
      backgroundPosition: "right",
      // border: `2px solid ${Color.bgDark}`,
      // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
    },
  },
  disabledPrimary: {
    backgroundColor: Color.lightGreen,
  },
};

export const ButtonStyle = {
  offWhite: {
    backgroundColor: "rgb(250,250,249)",
    color: "black",
    border: `1px solid ${Color.bgMed}`,
    "&:hover": {
      backgroundColor: `${Color.bgMed}`,
    },
  },
  red: {
    backgroundColor: "#F04D3B",
    color: "black",
    border: `1px solid #F04D3B`,
    "&:hover": {
      backgroundColor: `#EF301B`,
    },
  },
  primary: {
    backgroundColor: Color.primary,
    color: "black",
    border: `1px solid ${Color.primaryDark}`,
    "&:hover": {
      backgroundColor: `${Color.primaryDark}`,
    },
  },
};

export const MediaQuery = {
  sm: "screen and (min-width: 36em)",
  md: "screen and (min-width: 48em)",
  lg: "screen and (min-width: 64em)",
  mobile0: "screen and (max-width: 768px)",
  desktop1: "screen and (max-width: 1080px)",
  desktop2: "screen and (max-width: 1200px)",
};

export const SurveyColumn = {
  job_values: "job_values",
  job_location: "job_location",
  visa: "visa",
  timeframe: "timeframe",
  roles: "roles",
  years_experience: "years_experience",
  company_size: "company_size",
  industries: "industries",
  negative_industries: "negative_industries",
  skills: "skills",
  salary: "salary",
  demographics: "demographics",
  linkedin: "linkedin",
  email_frequency: "email_frequency",
  referred_by: "referred_by",
};

export const ContactType = {
  email: "email",
  phoneNumber: "phone_number",
  google: "google",
};
const q0 = {
  question: "What do you value most in a job?",
  short: "Job Values",
  description:
    "This will help us match you with companies who care about the same things you care about.",
  slug: "quality",
  column: SurveyColumn.job_values,
  // options: ['Challenging work', 'Diversity and inclusion', 'Meaningful work', 'Development and progression', 'Flexibility and wellbeing', 'Recognition and reward', 'Working with great people', 'Transparency and respect', 'Progressive leadership', 'Innovative product', 'Data driven decisions', 'Great tech and tools'],
  options: [
    "Impactful Work",
    "Diversity & Inclusion",
    "Innovative Product",
    "Autonomy",
    "Open Communication",
    "Mentorship",
    "Upward Mobility",
    "Work-Life Balance",
    "Corporate Social Responsiblity & Sustainability",
  ],
};

const q1 = {
  question: "Where is your preferred job location?",
  short: "Job Location",
  description: "It's a big, big world out there.",
  slug: "location",
  column: SurveyColumn.job_location,
  // options: ['Austin', 'Boston', 'Chicago', 'Denver', 'Los Angeles', 'Miami', 'New York', 'San Francisco Bay Area', 'Remote', 'Amsterdam', 'Barcelona', 'Berlin', 'Dublin', 'London', 'Paris', 'Toronto', 'Vancouver'],
  options: [
    "Austin",
    "Boston",
    "Chicago",
    "Denver",
    "Los Angeles",
    "Miami",
    "New York City",
    "San Francisco Bay Area",
    "Remote (in US)",
    "No Preference",
    "Atlanta",
    "London",
    "Philadelphia",
    "Remote (outside US)",
    "San Diego",
    "Seattle",
    "Toronto",
    "Vancouver",
    "Washington D.C.",
  ],
};

const q2 = {
  question: "Do you need a work visa?",
  short: "Visa",
  slug: "visa",
  column: SurveyColumn.visa,
  options: ["Yes, I require a visa for the US", "No, I don't require a visa"],
};

// const langs = ['French', 'German', 'Mandarin', 'Italian', 'Spanish', 'Dutch', 'Portuguese', 'Arabic', 'Hindi', 'Urdu']
// const extraLangs = ['Abkhazian', 'Afar', 'Afrikaans', 'Akan', 'Albanian', 'Amharic', 'Aragonese', 'Armenian', 'Assamese', 'Avaric', 'Avestan', 'Aymara', 'Azerbaijani', 'Bambara', 'Bashkir', 'Basque', 'Belarusian', 'Bengali', 'Bislama', 'Bosnian', 'Breton', 'Bulgarian', 'Burmese', 'Cantonese', 'Catalan', 'Central Khmer', 'Chamorro', 'Chechen', 'Chichewa', 'Chinese', 'Church Slavic', 'Chuvash', 'Cornish', 'Corsican', 'Cree', 'Croatian', 'Czech', 'Danish', 'Dari', 'Divehi', 'Dzongkha', 'Estonian', 'Ewe', 'Faroese', 'Farsi', 'Fijian', 'Finnish', 'Flemish', 'Fulah', 'Gaelic', 'Galician', 'Ganda', 'Georgian', 'Greek', 'Guarani', 'Gujarati', 'Haitian', 'Hausa', 'Hebrew', 'Herero', 'Hiri Motu', 'Hungarian', 'Icelandic', 'Ido', 'Igbo', 'Indonesian', 'Interlingua', 'Interlingue', 'Inuktitut', 'Inuktitut (Eskimo)', 'Inupiaq', 'Irish', 'Japanese', 'Javanese', 'Kalaallisut', 'Kannada', 'Kanuri', 'Kashmiri', 'Kazakh', 'Khmer', 'Kikuyu', 'Kinyarwanda', 'Kirghiz', 'Kiswahili', 'Komi', 'Kongo', 'Korean', 'Kurdish', 'Lao', 'Laotian', 'Lappish', 'Latin', 'Latvian', 'Limburgan', 'Lingala', 'Lithuanian', 'Luba-Katanga', 'Luxembourgish', 'Macedonian', 'Malagasy', 'Malay', 'Malayalam', 'Maltese', 'Manx', 'Maori', 'Marathi', 'Marshallese', 'Mongolian', 'Nauru', 'Navajo', 'Ndonga', 'Nepali', 'North Ndebele', 'Northern Sami', 'Norwegian', 'Norwegian Bokmål', 'Norwegian Nynorsk', 'Occitan', 'Ojibwa', 'Oriya', 'Oromo', 'Ossetian', 'Pali', 'Pashto', 'Persian', 'Polish', 'Punjabi', 'Quechua', 'Romanian', 'Romansh', 'Rundi', 'Russian', 'Samoan', 'Sango', 'Sanskrit', 'Sardinian', 'Scots', 'Serbian', 'Shona', 'Sichuan Yi', 'Sign languages', 'Sindhi', 'Sinhala', 'Slovak', 'Slovenian', 'Somali', 'South Ndebele', 'Southern Sotho', 'Sundanese', 'Swahili', 'Swati', 'Swedish', 'Tagalog', 'Tagalog-Filipino', 'Tahitian', 'Tajik', 'Tamil', 'Tatar', 'Telugu', 'Thai', 'Tibetan', 'Tigrinya', 'Tonga', 'Tongan', 'Tsonga', 'Tswana', 'Turkish', 'Turkmen', 'Twi', 'Uighur', 'Ukrainian', 'Uzbek', 'Venda', 'Vietnamese', 'Volapük', 'Walloon', 'Welsh', 'Western Frisian', 'Wolof', 'Xhosa', 'Yiddish', 'Yoruba', 'Zhuang', 'Zulu']
// langs.push(...extraLangs)

// const q3 = {
//     question: 'Which languages can you work in?',
//     slug: 'language-requirement',
//     options: langs,
// }

const q4 = {
  question: "What is your preferred start date for a new job?",
  short: "Start Date",
  slug: "timeframe",
  column: SurveyColumn.timeframe,
  options: [
    "As soon as possible",
    "In the next year",
    "Once the right opportunity arises",
    "I'm not actively seeking, but open to possibilities",
  ],
};

const roles = {
  "Software Engineering": [
    "Backend Engineer",
    "DevOps",
    "Engineering Management",
    "Frontend Engineer",
    "Full-stack Engineer",
    "QA & Testing Engineer",
    "Security Engineer",
    "Software Architect",
    "Support Engineer",
  ],
  "Gig Work": [
    "Tasker",
    "Delivery Driver",
    "Virtual Assistant",
    "Freelance Writer",
  ],
  Data: [
    "Data Analysis & BI",
    "Data Engineer",
    "Data Scientist",
    "Machine Learning Engineer",
    "Research Engineer",
  ],
  "Other Engineering": [
    "Hardware Engineer",
    "IT Support",
    "Mechanical Engineer",
    "Technical Writer",
  ],
  Product: [
    "Delivery Manager & Agile Coach",
    "Product Analyst",
    "Product Management",
    "Technical Product Management",
    "User Research",
  ],
  Design: [
    "Brand Design",
    "Graphic & Motion Design",
    "Industrial Design",
    "Product Design (UI/UX)",
    "UX Writer",
  ],
  "Operations & Strategy": [
    "Business Operations & Strategy",
    "Customer Service & Support",
    "Operations Generalist",
    "Project & Programme Management",
  ],
  "Sales & Account Management": [
    "Account Executive",
    "Customer Success & Account Management",
    "Enterprise Sales",
    "Partnerships",
    "Sales & Business Development",
    "Sales Leadership & Management",
    "Sales Operations",
    "Technical Account Management",
  ],
  Marketing: [
    "Brand & Creative Marketing",
    "Content Marketing",
    "Copywriter",
    "CRM & Marketing Operations",
    "Generalist Marketing",
    "Growth Marketing",
    "Performance Marketing",
    "PR & Communications",
    "Product Marketing",
    "SEO Marketing",
    "Social Media & Community",
  ],
  "People, HR, Recruitment": [
    "Administration",
    "Executive Assistant",
    "Generalist Recruitment",
    "Human Resources",
    "People Operations",
    "Technical Recruitment",
  ],
  "Finance, Legal & Compliance": [
    "Accounting",
    "Actuary",
    "Asset Management",
    "Auditor",
    "Corporate Finance",
    "Financial Analyst",
    "Financial Planning",
    "Finance Operations",
    "Hedge Fund",
    "Investment Banking",
    "Legal",
    "Private Equity",
    "Risk & Compliance",
    "Trading",
    "Venture Capital",
    "Wealth Management",
  ],
  Healthcare: [
    "Home Health Aide",
    "Medical Assistant",
    "Patient Care Technician",
    "Patient Service Representative",
    "Pharmacy Technician",
  ],
};
export const roleTitles = [
  "Sales & Account Management",
  "Gig Work",
  "Software Engineering",
  "Other Engineering",
  "Data",
  "Product",
  "Design",
  "Operations & Strategy",
  "Marketing",
  "People, HR, Recruitment",
  "Finance, Legal & Compliance",
  "Healthcare",
];
const roleOptions = [];
export const roleCutoffs = [0];
roleTitles.forEach((role) => {
  roleOptions.push(role);
  roleCutoffs.push(roleCutoffs[roleCutoffs.length - 1] + roles[role].length);
});
roleTitles.forEach((role) => roleOptions.push(...roles[role]));
const q5 = {
  question: "What line of work are you interested in?",
  short: "Line of work",
  description:
    "Tell us what you think you'll crush at so we can help you find your dream job.",
  slug: "dream-job",
  column: SurveyColumn.roles,
  cutoffs: roleCutoffs.filter((_, i) => i > 0),
  options: roleOptions,
};

const q6 = {
  question: "What level role are you looking for?",
  short: "Experience level",
  description: "You'll be climbing that ladder in no time.",
  slug: "experience",
  column: SurveyColumn.years_experience,
  options: [
    "Internships",
    "Entry-level/Graduate",
    "Junior (1-2 years)",
    "Mid-level (3-4 years)",
    "Senior (5-8 years)",
    "Expert & Leadership (9+ years)",
  ],
};

const q7 = {
  question: "What size company would you like to work for?",
  short: "Company size",
  description: "Startup energy? Polished corporation? The choice is yours.",
  slug: "company-size",
  column: SurveyColumn.company_size,
  options: [
    "No Preference",
    "1-20 employees",
    "21-100 employees",
    "101-200 employees",
    "201-500 employees",
    "501-1000 employees",
    "1001+ employees",
  ],
};

const industries = [
  "B2C",
  "Retail",
  "B2B",
  "Artificial Intelligence",
  "Security",
  "Enterprise Software",
  "Marketplace",
  "Education",
  "Productivity",
  "Hardware",
  "Real Estate",
  "SaaS",
  "Media",
  "eCommerce",
  "Science",
];
const extraIndustries = [
  "Accelerator",
  "Accessibility",
  "Accounting",
  "Advertising",
  "Aerospace",
  "Age-tech",
  "Agency",
  "Agriculture",
  "Analytics",
  "API",
  "Art",
  "Augmented Reality",
  "Automation",
  "Automotive",
  "Banking",
  "Beauty",
  "Big data",
  "Biology",
  "Biotechnology ",
  "Blockchain",
  "Bookkeeping",
  "Business Intelligence",
  "Capital Markets",
  "Cars",
  "Charity",
  "Childcare",
  "Cloud Computing",
  "Communication",
  "Community",
  "Compliance",
  "Computer Vision",
  "Construction",
  "Consulting",
  "Consumer Appliances",
  "Consumer Goods",
  "Consumer Software",
  "Content",
  "Credit cards",
  "Credit Scoring",
  "Crowdfunding",
  "Crypto & Web 3",
  "Customer service",
  "Cybersecurity",
  "D2C",
  "Data Analysis",
  "Data Integration",
  "Data Sharing",
  "Data Storage",
  "Dating",
  "Deep Tech",
  "Delivery",
  "Dentistry",
  "Design",
  "DevOps",
  "Digital Media",
  "Discount",
  "Drones",
  "Electric Vehicles",
  "Energy",
  "Entertainment",
  "Environmental",
  "eSports",
  "Events",
  "Fashion",
  "Femtech",
  "Financial Services",
  "Fintech",
  "Fitness",
  "Flexible working",
  "Flights",
  "Flowers",
  "Food",
  "Foreign exchange",
  "Fraud",
  "Freight",
  "Fundraising",
  "Furniture",
  "Gambling",
  "Gaming",
  "Governments",
  "Healthcare",
  "Home improvement",
  "Hospitality",
  "HR",
  "Identity",
  "Incubator",
  "Insurance",
  "Interior design",
  "Internal Tools",
  "Internet of Things",
  "Investing",
  "Kids",
  "Languages",
  "Lead generation",
  "Learning",
  "Legal",
  "Lending",
  "Lifestyle",
  "Location services",
  "Logistics",
  "Machine Learning",
  "Manufacturing",
  "Market research",
  "Marketing",
  "MedTech",
  "Mencare",
  "Mental health",
  "Mobile",
  "Mobility",
  "Mortgages",
  "Music",
  "Nature",
  "Navigation",
  "Networking",
  "No-Code",
  "Nutrition",
  "Office",
  "Outsourcing",
  "Payments",
  "Personal finance",
  "Personal health",
  "Petroleum",
  "Pets",
  "Printing",
  "Privacy",
  "Procurement",
  "Procurement ",
  "Product Management",
  "Property",
  "Publishing",
  "Quantitative Finance",
  "Recruitment",
  "Regtech",
  "Renting",
  "Reviews",
  "Ridesharing",
  "Robotics",
  "Sales",
  "Sharing Economy",
  "Social",
  "Social Impact",
  "Social Media",
  "Sports",
  "Strategic Intelligence",
  "Subscription",
  "Supply Chain",
  "Sustainability",
  "Telecommunications",
  "Ticketing",
  "Toys",
  "Trading",
  "Training",
  "Transport",
  "Travel",
  "Tutoring",
  "Venture Capital",
  "Video",
  "Virtual Reality",
  "Visualisation",
  "Web Design",
  "Weddings",
  "Wellbeing",
];

const q8 = {
  question: "What industries are you interested in?",
  short: "Interested Industries",
  description: "Decisions, decisions.",
  slug: "industries",
  column: SurveyColumn.industries,
  options: [...industries, ...extraIndustries],
};

const q9 = {
  question: "Are there any industries you prefer not to work in?",
  short: "Negative Industries",
  slug: "negative-industries",
  column: SurveyColumn.negative_industries,
  options: ["No", "Yes", ...[...industries, ...extraIndustries].sort()],
};

const technologies = [
  "Python",
  "Linux",
  "Excel",
  "Windows",
  "C++",
  "C",
  "NetSuite",
  "JIRA",
  "Azure",
  "Bash",
  "macOS",
  "Active Directory",
  "AWS",
  "MatLab",
  "Powershell",
  "Okta",
  "Perl",
  "Slack",
  "SQL",
  "Looker",
  "Salesforce",
  "Quickbooks",
  "SAP",
  "Zoom",
  "GSuite",
];
const extraTechnologies = [
  "Abstract",
  "Adjust",
  "Adobe Campaign",
  "Adobe Creative Suite",
  "Adobe Experience Manager",
  "Adobe Omniture",
  "Adobe Premiere",
  "After Effects",
  "Ahrefs",
  "Aircall",
  "Airflow",
  "Airtable",
  "Alamofire",
  "Alexa",
  "Amazon Marketing Services",
  "Amplitude",
  "Android",
  "Angular 8+",
  "AngularJS",
  "Ansible",
  "Apollo",
  "Appium",
  "Appsflyer",
  "Asana",
  "ASP.NET",
  "Athena",
  "Atlassian",
  "Axure",
  "Babel",
  "Backbone",
  "Balsamiq",
  "Bazel",
  "Blackarch",
  "Bootstrap",
  "Branch",
  "Braze",
  "Browserstack",
  "Campaign Monitor",
  "Canva",
  "Capybara",
  "Card.IO",
  "Cassandra",
  "Chartio",
  "Clearbit",
  "CMake",
  "Cocoa Touch",
  "CUDA",
  "Dagger",
  "Data Flow",
  "Data Studio",
  "DAX",
  "DeepCrawl",
  "Demandbase",
  "Dialpad",
  "Django",
  "Dotmailer",
  "Dreamweaver",
  "Elasticsearch",
  "Eloqua",
  "Emarsys",
  "Engagio",
  "Erlang",
  "Exasol",
  "Facebook Ads",
  "Fastlane",
  "Figma",
  "Filemaker",
  "Firebase",
  "Flask",
  "Flowchart",
  "Framer",
  "Gainsight",
  "Gatling",
  "Gatsby",
  "gola",
  "Google AdWords",
  "Google Analytics",
  "Gradle",
  "Grafana",
  "GraphQL",
  "GraphX",
  "Hadoop",
  "Hakyll",
  "Hapi",
  "HappyFox",
  "Haskell",
  "HBase",
  "Hibernate",
  "Hotjar",
  "IBM Acoustic",
  "Illustrator",
  "Indicative",
  "Insomnia",
  "Jasmine",
  "Java",
  "JavaScript",
  "Julia",
  "Kafka",
  "Kali",
  "Karma",
  "Kayako",
  "Keras",
  "Keyword Planner",
  "Kibana",
  "Koa",
  "Laravel",
  "Liquidsoap",
  "LiveAgent",
  "Logstash",
  "Lua",
  "LuckyOrange",
  "Lusha",
  "MailChimp",
  "MapReduce",
  "Marin",
  "Marketo",
  "MarvelApp",
  "Maven",
  "Maya",
  "Media Controller",
  "MessageBird",
  "Metabase",
  "MicroStrategy",
  "Mixpanel",
  "MixPanel",
  "Mocha",
  "Mode Analytics",
  "Neolane",
  "Octane",
  "Olark",
  "Ometria",
  "OpenMAX",
  "Oracle",
  "Origami",
  "Outreach",
  "Pandas",
  "Pardot",
  "Parquet",
  "Parrot OS",
  "Pearl",
  "Pentaho",
  "Piktochart",
  "Postman",
  "Protractor",
  "Quay.io",
  "RabbitMQ",
  "Rails",
  "React",
  "React Native",
  "Realm",
  "Relay",
  "REST API",
  "Rholang",
  "Ruby on Rails",
  "RxJava",
  "RxJavaScript",
  "Sage",
  "Sagemaker",
  "Sailthru",
  "Salesflare",
  "Saltstack",
  "Scala",
  "Scalding",
  "Scikit-Learn",
  "Scrapy",
  "Screaming Frog",
  "Search Ads 360",
  "Semantic",
  "Similar Web",
  "Sinatra",
  "Smartly",
  "Snowflake",
  "SpaCy",
  "Spark",
  "Spinnaker",
  "Stackdriver",
  "Substance Painter",
  "Tableau",
  "Talend",
  "Teamcity",
  "terra",
  "Terraform",
  "Theano",
  "ToBraid",
  "Tomcat",
  "Tornado",
  "Unbabel",
  "UNICA",
  "Unreal Engine",
  "Vaadin",
  "VBA",
  "Vertica",
  "Visualforce",
  "Visual Studio",
  "VMware vSphere",
  "Vonage",
  "vSAN",
  "Wave",
  "Whimsical",
  "Whiteboard",
  "Wireframe",
  "Workwave",
  "Xamarin",
  "Yarn",
  "Zapier",
  "Zuora",
];

const q10 = {
  question:
    "Are there any technologies that you have experience using or would like to highlight?",
  short: "Skills/Technologies",
  slug: "technologies",
  column: SurveyColumn.skills,
  isImportant: true, // important meaning user can double click on option to make it "important"
  options: ["Yes", "No", ...technologies, ...extraTechnologies],
};

// const q11 = {
//     question: 'Are there any technologies you don\'t want to work in?',
//     slug: 'negative-technologies',
//     options: ['No', 'Yes', ...([...technologies, ...extraTechnologies].sort())],
// }

const salaries = [];
for (let sal = 5; sal < 40; sal += 1) {
  salaries.push(sal);
}
for (let sal = 40; sal < 80; sal += 2) {
  salaries.push(sal);
}
for (let sal = 80; sal < 150; sal += 5) {
  salaries.push(sal);
}
for (let sal = 150; sal < 250; sal += 10) {
  salaries.push(sal);
}
for (let sal = 250; sal < 525; sal += 25) {
  salaries.push(sal);
}

const q12 = {
  question: "What is your minimum desired salary?",
  description: "Put it out into the universe.",
  slug: "salary",
  column: SurveyColumn.salary,
  options: [...salaries],
};

const pronouns = ["She/Her", "He/Him", "They/Them", "Prefer not to say"];
const genders = [
  "Female",
  "Male",
  "Non-binary",
  "Transgender",
  "Prefer not to say",
];
const ethnicities = [
  "Black or African American",
  "East Asian",
  "Indigenous Peoples",
  "Hispanic or Latino",
  "Middle Eastern",
  "Native Hawaiian",
  "South Asian",
  "Southeast Asian",
  "White",
  "Multiracial / Multiethnic",
  "Other",
  "Prefer not to say",
];

const q13 = {
  question: "Wanna tell us more?",
  description: "(This info is completely optional!)",
  slug: "demographic",
  column: SurveyColumn.demographics,
  options: [...pronouns, ...genders, ...ethnicities],
};

const q14 = {
  question: "Your first 10 matches are in...",
  slug: "sign-up",
  column: null,
  options: [],
};

const q15 = {
  // question: 'Would you like to be contacted directly by companies that match your preferences?',
  question: "Connect your LinkedIn",
  short: "LinkedIn",
  slug: "linkedin",
  column: SurveyColumn.linkedin,
  useInputText: true,
  options: [],
  // https://www.linkedin.com/in/?original_referer=https%3A%2F%2Fapp.otta.com%2F
};

const q16 = {
  question: "How often would you like to be notified about new jobs?",
  slug: "email-frequency",
  column: SurveyColumn.email_frequency,
  options: ["Daily", "Weekly", "Never"],
};

const q17 = {
  question: "Where did you hear about Fetti?",
  slug: "signup-reason",
  column: SurveyColumn.referred_by,
  options: [
    "TikTok",
    "Instagram",
    "Facebook",
    "LinkedIn",
    "Google/Search Engine",
    "Youtube",
    "School",
    "Advertisement",
    "Friend or Colleague",
    "Other",
  ],
};
const qResume = {
  question: "Upload your resume",
  description:
    "This helps us match you with the perfect job, and lets you submit applications in one click",
  slug: "resume",
  column: null,
  options: [],
};
const qSchools = {
  question: "Where did you go to school?",
  description: "You can always update your information",
  slug: "education",
  column: null,
  options: [],
};

export const QuestionData = [
  q0,
  q1,
  q2,
  // q3, // language
  q4,
  q5,
  q6,
  q7,
  q8,
  q9,
  q10,
  // q11, // negative technologies
  q12,
  q13,
  q14,
  qResume,
  qSchools,
  q15,
  q16,
  q17,
];

// gig survey will use GigQuestionData order, but the surveyReducer will still use QuestionData order
export const GigQuestionData = [q1, q2, q4, q12, q0, q13, q14, q16, q17];

export const signupIdx = QuestionData.findIndex((q) => q.slug === "sign-up");
export const schoolsIdx = QuestionData.findIndex((q) => q.slug === "education");
export const resumeIdx = QuestionData.findIndex((q) => q.slug === "resume");
export const gigSignupIdx = GigQuestionData.findIndex(
  (q) => q.slug === "sign-up"
);
export const SEPARATOR = ";;";

export const JobClickType = {
  copy: "copy",
  applyNow: "applyNow",
  viewMore: "viewMore",
  video: "video",
};

export const JobDisplays = {
  borderRadius: "10px",
  backgroundColor: "#fff",
  //   backgroundColor: "#FFFC0030",
  //   boxShadow: "none",
  boxShadow: "2px 2px 8px rgb(0 0 0 / 10%)",
  boxShadowStrong: "2px 2px 10px rgb(0 0 0 / 25%)",
  padding: "16px",
};

export const EducationTags = {
  all: "all",
  internships: "internships",
  resume: "resume",
  university: "university",
  interview: "interview",
  professionalDevelopment: "professionalDevelopment",
  leadership: "leadership",
  skillDevelopment: "skillDevelopment",
  whileYoureAtWork: "whileYoureAtWork",
  networking: "networking",
};
export const EducationCategories = [
  EducationTags.all,
  EducationTags.internships,
  // EducationTags.resume,
  // EducationTags.university,
  EducationTags.interview,
  EducationTags.professionalDevelopment,
  // EducationTags.leadership,
  // EducationTags.skillDevelopment,
  // EducationTags.whileYoureAtWork,
  EducationTags.networking,
];
export const EducationTagToName = {
  all: "All",
  internships: "Internships",
  resume: "Resume",
  university: "University",
  interview: "Interview",
  professionalDevelopment: "Professional Development",
  leadership: "Leadership",
  skillDevelopment: "Skill Development",
  whileYoureAtWork: "While You're At Work",
  networking: "Networking",
};

export const EduPostTypes = {
  text: "text",
  video: "video",
};

export const AccountType = {
  standard: "standard",
  gig: "gig",
  affiliate: "affiliate",
};

export const AffOp = {
  landed: "landed",
  signed_up: "signed_up",
};

export const SignupFor = {
  affiliate: "affiliate",
};

export const ApplicationInputStyle = {
  stackProps: {
    direction: "column",
    alignItems: "flex-start",
    spacing: 1,
  },
  optional: {
    fontSize: "10px",
  },
  stack: {
    width: "100%",
    // maxWidth: "310px",
  },
  headerNewSection: {
    paddingTop: "24px",
    fontSize: { xs: "18px", sm: "24px" },
  },
  categoryLabel: {
    width: "100%",
    textAlign: "left",
    fontSize: { xs: "20px", sm: "22px" },
    fontWeight: "bold",
  },
  header: {
    ...FontStyle.headingBody,
    fontSize: { xs: "14px", sm: "14px" },
  },
  subheader: {
    ...FontStyle.body,
    fontSize: "14px",
    color: Color.secondaryTextGray,
  },
  error: {
    fontSize: "14px",
    color: "red",
  },
  dash: {
    width: "20px",
    height: "2px",
    backgroundColor: "#000",
    borderRadius: "2px",
  },
};
export const applyMaxLengths = {
  firstName: 50,
  lastName: 50,
  email: 50,
  location: 50,
  phone: 50,
};

export const Panels = {
  borderRadius: "10px",
  backgroundColor: "#fff",
  //   backgroundColor: "#FFFC0030",
  //   boxShadow: "none",
  boxShadow: "2px 2px 8px rgb(0 0 0 / 10%)",
  padding: "16px",
  py: "24px",
  px: { xs: "16px", sm: "24px" },
  border: "1px solid #E5E5E5",
};

// in messages, subs in for current user's userId
export const userStr = "user";

export const VideoOrientation = {
  landscape: "landscape",
  portrait: "portrait",
};

export const S3Op = {
  upload_profile_pic: "upload_profile_pic",
};
export const S3FetchOp = {
  get_own_profile_pic: "get_own_profile_pic",
  delete_own_profile_pic: "delete_own_profile_pic",
  applicant_get_recruiter_profile_pic: "applicant_get_recruiter_profile_pic",
};

export const jobPageSizing = {
  0: {
    mid: "100%",
    left: "100%",
    right: "100%",
    maxWidth: "576px",
  },
  1: {
    mid: "446px",
    left: "300px",
    // left: "250px",
  },
  2: {
    mid: "400px",
    left: "275px",
    right: "250px",
  },
  3: {
    // sums to 1154
    mid: "579px",
    left: "275px",
    right: "300px",
  },
};
export const matchesOnlySizing = {
  0: {
    mid: "100%",
    left: "100%",
    right: "100%",
    maxWidth: "576px",
  },
  1: {
    mid: "100%",
    left: "275px",
    // left: "250px",
  },
  2: {
    mid: "800px",
    // mid: "400px",
    left: "275px",
    // right: "250px",
  },
  3: {
    // sums to 1154
    mid: "800px",
    // mid: "579px",
    left: "300px",
    // right: "300px",
  },
  // 3: { # sums to 1080
  //   mid: "555px",
  //   left: "225px",
  //   right: "300px",
  // },
};

export const ToolbarStyle = {
  stackProps: {
    direction: "row",
    alignItems: "center",
  },
  stackStyle: {
    ...FontStyle.headingBody,
    fontSize: "14px",
    backgroundColor: "#ffffff",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    py: "8px",
    px: "12px",
    width: "fit-content",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    "&:active": {
      backgroundColor: "#e0e0e0",
    },
  },
};
